import React from "react";
import "../style/fordentist.css";
import { ToothZapFooter } from "../layouts/footer";
import { Nav } from "../layouts/header";

export default function Forlabs() {
  return (
    <div className="fd-wrapper">
          <Nav />
      <div className="container tz-container ">
        <section className="fd-fordentistse">
          <div className="fd-hero-left ">
            <p className="fd-tag">
             Partner with ToothZap — Grow Your Dental Milling Business in Delhi
            </p>

            <h1>
          Fill your idle capacity with routed same-day crown demand.
            </h1>

            <p className="fd-desc">
           ToothZap helps Delhi milling hubs turn unused production time into consistent restorative work by routing cases, managing logistics, and standardizing handoffs.
            </p>

            <div className="fd-buttons py-2">
              <button className="primary-btn-join-us">Partner With Us</button>
          
            </div>
          </div>

   
          <div className="fd-card-section pt-lg-5 ">
            <div className="table-section-dentist">
                <div className="chaiside-live">
           <div className="logo-wrapper-part">
  

  <div className="icon-circle-sect">
    <i className="bi bi-lightning-fill"></i>
  </div>


  <div className="logo-text">
    <div className="toothzap">ToothZap</div>
    <div className="dashboard-text">Milling dashboard</div>
  </div>

           </div>
           <div className="chair-sidediv">
          Live queue

           </div>
              
              </div>
                
                
                
               
            </div>
           

            <div className="stats padding-20px">
              <div>
                <h3>11</h3>
                <p>Active Orders</p>
              </div>
              <div>
                <h3>01</h3>
                <p>Awaiting Response</p>
              </div>
              <div>
                <h3>02</h3>
                <p>Needs Attention</p>
              </div>
              <div>
                <h3>08</h3>
                <p>On Time</p>
              </div>
            </div>
            <div className="table-wrapper">
<div className="table-maindiv">
            <table  className="padding-30px table-sectionhere">
                <thead>
 
                    <tr>
                        <th>Order ID</th>
                        <th>Assigned Hub</th>
                        <th>Milling</th>
                        <th>Status</th>
                    </tr>
                </thead>
     

              <tbody>
                <tr>
                  <td>TZ123</td>
                  <td>Crown Experts</td>
                  <td>Acceptance Overdue</td>
                  <td className="red">Needs Attention</td>
                </tr>
                <tr>
                    <td>TZ123</td>
                  <td>Crown Experts</td>
                  <td>In Milling</td>
                  <td className="green">On Time </td>
                </tr>
      
                <tr>
                  <td>TZ123</td>
                  <td>Milling Kings</td>
                  <td>Ready for Milling</td>
                  <td>Awaiting Response</td>
                </tr>
  
                <tr>
                  <td>TZ123</td>
                  <td>Dental Millers</td>
                  <td>Done</td>
                  <td >Completed</td>
                </tr>
              </tbody>
            </table>
            </div>
            </div>
          </div>
        </section>
        <section className="fd-section row">
            <div className="col-md-6">
                <p className="section-label-benefits">The Opportunity</p>
          <h2>
         Most milling hubs run at 60–70% capacity.
          </h2>
          </div>
  <div className="col-md-6">
          <div className="fd-grid-2-sec">
         

            <div className="fd-card">
              <h4 className="idle-time">Idle time</h4>
                <p className="lab-delay">
            High-value machine hours are often left unused between scheduled cases, even when local demand exists nearby.
              </p>
            </div>

            <div className="fd-card">
            <h4 className="idle-time">Revenue drag</h4>
               <p className="lab-delay">
           Labs absorb fixed operating costs while capacity sits idle because acquiring enough direct clinic demand is expensive and slow.
              </p>
            </div>
          </div>
          </div>
        </section>

        <section className="fd-section row pt-5">
              <div className="col-md-7">
                <p className="section-label-benefits">How Partnership Works</p>
          <h2>
          ToothZap handles materials, design files, pickup, delivery, and QC coordination so your hub can stay focused on milling.
          </h2>
          </div>

            <div className="fd-grid-3">
  {[
    {
      title: "Join",
      desc: "We align on machine capability, turnaround standards, quality checks, and service-zone capacity before routing cases."
    },
    {
      title: "Receive cases",
      desc: "ToothZap sends ready-to-run design files and handles materials coordination so your team can focus on production throughput."
    },
    {
      title: "Mill & handoff",
      desc: "You mill the case and complete the handoff while ToothZap manages pickup, delivery, and final logistics to the clinic."
    },
 
  ].map((item, i) => (
    <div className="fd-card" key={i}>
      <span className="fd-numberforlabs">0{i + 1}</span>
      <h3 className="for-labsh4">{item.title}</h3>
      <p className="card-description">{item.desc}</p>
    </div>
  ))}
</div>
        </section>
</div>
  
  
 <div className="container tz-container">
     <div className="row">
         <div className="col-md-8">
                <p className="section-label">Benefits</p>
           <h2 className="what-delhi-dentist">What milling hubs gain from the partnership</h2>
          </div>
          </div>
        <section className="fd-section">
       

         <div className="fd-grid-3">
  {[
    {
      title: "Consistent case flow",
      desc: "Keep machines productive across the day with routed restorative demand from active Delhi clinics."
    },
    {
      title: "Materials provided",
      desc: "ToothZap coordinates the material and design-file layer so your team can stay focused on execution."
    },
    {
      title: "No delivery logistics",
      desc: "Pickup and last-mile handoff are managed centrally instead of becoming one more operational burden on the lab."
    },
    {
      title: "Lab dashboard",
      desc: "Track queued work, ETA expectations, and case status from one operating view built around turnaround targets."
    },
    {
      title: "Quality materials",
      desc: "Production is supported by standardized inputs that reduce avoidable variation across urgent same-day cases."
    },
    {
      title: "Growth without dentist acquisition cost",
      desc: "Increase revenue and utilization without investing in direct clinic acquisition or outbound sales overhead."
    }
  ].map((item, i) => (
    <div className="fd-card" key={i}>
      <span className="fd-number">0{i + 1}</span>
      <h4>{item.title}</h4>
      <p className="card-description">{item.desc}</p>
    </div>
  ))}
</div>
        </section>

       <section className="fd-section">
  <div className="row">
    
    {/* LEFT SIDE */}
    <div className="col-md-5  lab-dashboard-preview">
      <p className="section-label-benefits">Lab Dashboard Preview</p>

      <h2 className="what-delhi-dentist-gain">
 View queued cases, turnaround commitments, <br/> and pickup readiness from one milling-side console.
      </h2>

      <p className="card-description2">
 The dashboard is designed to help hubs plan machine time around routed work without adding extra coordination overhead.
      </p>

    </div>

    {/* RIGHT SIDE */}
    <div className="col-md-7">
      <div className="fd-dark-card">
        <div className="todays-active">
   <div className="today-active">
    <div className="clinic-queue">Hub Queue</div>
      <h4>Active milling jobs</h4>
   </div>
   <div className="btn-section">
    <button className="primary-btn-join-us">3 Active</button>
   </div>
        </div>
  
      <div className="r-malhotra-section">
        <div className="malhotra-detail">
            <div className="t-z-184">  LAB-2201</div>
 <div className="case">South Delhi Smile Studio</div>
 <div className="cad-in">Queued for milling</div>
        </div>
        <div className="14-min">
            <div className="ETA">ETA</div>
            <div className="min-14">12 min</div>
        </div>

      </div>
    
           <div className="r-malhotra-section">
        <div className="malhotra-detail">
            <div className="t-z-184">  LAB-2202</div>
 <div className="case">CP Smile Atelier</div>
 <div className="cad-in">Polish & QC</div>



        </div>
        <div className="14-min">
            <div className="ETA">ETA</div>
            <div className="min-14">7 min</div>
        </div>

      </div>
   
          <div className="r-malhotra-section">
        <div className="malhotra-detail">
            <div className="t-z-184">  LAB-2203</div>
 <div className="case">Rohini Digital Dentistry</div>
 <div className="cad-in">Ready for pickup</div>
        </div>
     
        <div className="14-min">
            <div className="ETA">ETA</div>
            <div className="min-14">Dispatching</div>
        </div>

      </div>
        
      </div>
    </div>

  </div>
</section>
   </div>
    <section className="fd-blue container-fluid">
        <div className="container tz-container">
            <div className="row">
                <div className="col-md-12">
                    <p className="testimonials">Dentist Testimonials</p>
What milling partners value most
                </div>
            </div></div>
      
       
        </section>

        <section className="fd-cta">
               <h2 className="what-delhi-dentist py-5 mb-5">Questions milling hubs ask before partnering</h2>
          <h2  className="what-delhi-dentist mt-2">Ready to fill idle capacity with routed same-day <br/> crown work?</h2>
   
           <button className="primary-btn-join-us mt-1">Partner as a Milling Hub</button>
        </section>
   
        <ToothZapFooter />
    </div>
   
  );
}